import { render, staticRenderFns } from "./KontaktAnfahrt.vue?vue&type=template&id=319c2d4a&scoped=true&"
import script from "./KontaktAnfahrt.vue?vue&type=script&lang=js&"
export * from "./KontaktAnfahrt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c2d4a",
  null
  
)

export default component.exports